import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import MonthlyPicksSection from "@/pages/categories/components/MonthlyPicksSection";
import BrandSection from "@/pages/categories/components/BrandSection";

const CategoriesPage = () => (
  <div className="min-h-screen bg-white">
    <Navbar />
    <main className="pt-24 pb-20">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Page Header */}
        <div className="mb-12">
          <p className="text-xs font-bold tracking-widest uppercase text-stone-400 mb-2">Products</p>
          <h1 className="text-3xl md:text-4xl font-black text-stone-900" style={{ fontFamily: "'Playfair Display', serif" }}>
            제품 안내
          </h1>
          <p className="text-sm text-stone-500 mt-2">이달의 인기제품과 브랜드별 라인업을 확인하세요.</p>
        </div>

        {/* 이달의 인기제품 */}
        <MonthlyPicksSection />

        {/* 구분선 */}
        <div className="border-t border-stone-100 mb-14" />

        {/* 브랜드별 제품 */}
        <BrandSection />
      </div>
    </main>
    <Footer />
  </div>
);

export default CategoriesPage;
